export function dogGroomingPaymentPreview(totalCents: number, requestedCount: number, configuredMaximum: number) {
  const maximum = Math.max(1, Math.floor(Number(configuredMaximum) || 1));
  const count = Math.min(maximum, Math.max(1, Math.floor(Number(requestedCount) || 1)));
  const total = Math.max(0, Math.round(Number(totalCents) || 0));
  const regularPaymentCents = count > 1 ? Math.floor(total / count) : total;
  const finalPaymentCents = total - regularPaymentCents * (count - 1);

  return {
    maximum,
    count,
    totalCents: total,
    regularPaymentCents,
    finalPaymentCents,
  };
}
